import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  BarChart,
  Bar,
  XAxis,
  Tooltip,
  ResponsiveContainer
} from "recharts";
import { parentDailyUsageAction, studentDailyUsageAction } from "../../../Redux/Action/StudentAction";
import { collectionDailyUsageAction } from "../../../Redux/Action/CollectionAction";
import { convertTime } from "../../../Util/HelperFunction";

export default function ChartUsers({ setWeekCount, selectedWeek, selecteDates, idval, type }) {
  const [chartData, setChartData] = useState([]);

  const dispatch = useDispatch();
  useEffect(() => {
    const Payload = {
      id: idval,
      date: {
        startOfWeek: selecteDates.startOfWeek || "",
        endOfWeek: selecteDates.endOfWeek || "",
      }
    };

    if (type === "student") {
      calculateStudentWeek(Payload);
    } else if (type === "teacher") {
      calculateWeek(Payload);

    } else if (type === "parent") {
      calculateParentWeek(Payload);

    } else {
     
    }
  }, [dispatch, idval, selectedWeek, selecteDates]);

  const calculateWeek = async (Payload) => {
    const data = await dispatch(collectionDailyUsageAction(Payload));

    if (data.payload.statusCode === 200) {
      setWeekCount(data.payload.data.averageMinutes);
      setChartData(data.payload.data.result.map(item => ({
        day: item.day,
        minutes: Math.trunc(item.minutes)  // Truncate minutes to remove decimal places
      })));
    }
  };

  const calculateStudentWeek = async (Payload) => {
    const data = await dispatch(studentDailyUsageAction(Payload));

    if (data.payload.statusCode === 200) {
      setWeekCount(data.payload.data.averageMinutes);
      setChartData(data.payload.data.result.map(item => ({
        day: item.day,
        minutes: Math.trunc(item.minutes)  // Truncate minutes to remove decimal places
      })));
    }
  };


  const calculateParentWeek = async (Payload) => {
    const data = await dispatch(parentDailyUsageAction(Payload));
    if (data.payload.statusCode === 200) {
      setWeekCount(data.payload.data.averageMinutes);
      setChartData(data.payload.data.result.map(item => ({
        day: item.day,
        minutes: Math.trunc(item.minutes)  // Truncate minutes to remove decimal places
      })));
    }
  };




  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const { minutes } = payload[0].payload;
      return (
        <div className="custom-tooltip">
          <p>{payload[0].payload.day}</p>
          <p>{convertTime(minutes)}</p>  
        </div>
      );
    }

    return null;
  };

  return (
    <ResponsiveContainer width="100%" height={260} style={{ display: "flex", alignItems: "center" }}>
      <BarChart
        className="Bar-chart"
        data={chartData}
      >
        <XAxis dataKey="day" />
        <Tooltip content={<CustomTooltip />} />  
        <Bar dataKey="minutes" fill="#4318ff" name="Total Minutes" radius={[10, 10, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}
